import "./StreamingReports.scss";
import { ExtremeReachReport } from "./ExtremeReachReport";
import { FlashtalkingReport } from "./FlashtalkingReport";
import { NonLiveReport } from "./NonLiveReport";
import { Page } from "../Components";
import { Router } from "@reach/router";
import { useTabbedNav } from "../utils/hooks/useNav";
import InvalidRotationsReport from "./InvalidRotationsReport";
import React from "react";

const NON_LIVE_KEY = "nonlive";
const ER_REPORT_KEY = "er-sync";
const INVALID_ROTATION_KEY = "invalid-rotations";
const FT_REPORT_KEY = "ft-sync";
const NAVS = [NON_LIVE_KEY, ER_REPORT_KEY, INVALID_ROTATION_KEY, FT_REPORT_KEY];

export default React.memo(({ navigate }) => {
  const { tab, goToTab } = useTabbedNav({
    navigate,
    baseURL: "streaming/reports",
    defaultKey: NON_LIVE_KEY,
    navs: NAVS,
  });

  return (
    <Page
      title="Streaming Reports"
      pageType="Streaming Reports"
      navs={[
        {
          label: "Non-Live",
          key: NON_LIVE_KEY,
        },
        {
          label: "ER vs BPM",
          key: ER_REPORT_KEY,
        },
        {
          label: "Invalid Rotations",
          key: INVALID_ROTATION_KEY,
        },
        {
          label: "FT vs BPM",
          key: FT_REPORT_KEY,
        },
      ]}
      selectedNav={tab}
      onNav={goToTab}
    >
      <div className="streamingReportsPage">
        <Router className="fullPageRouter">
          <NonLiveReport path={NON_LIVE_KEY} />
          <ExtremeReachReport path={ER_REPORT_KEY} />
          <InvalidRotationsReport path={INVALID_ROTATION_KEY} />
          <FlashtalkingReport path={FT_REPORT_KEY} />
          <NonLiveReport default />
        </Router>
      </div>
    </Page>
  );
});
